import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import playerReducer from './reducers/playerReducer'

const rootReducer = combineReducers({
    player: playerReducer
})

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js